import { Component, Input } from '@angular/core';

@Component({
  selector: 'mat-icon',
  template: `<i
    [class]="getVariantIcon()"
    [ngStyle]="{ fontSize: size ? size + 'px' : 'inherit', color: color }"
    style="display: flex;"
    ><ng-content></ng-content></i
  >`,
})
export class IconsMaterialComponent {
  @Input() size?: number;
  @Input() color: string = 'inherit';
  @Input() variant: 'filled' | 'outlined' | 'round' | 'twoTone' = 'filled';

  getVariantIcon() {
    switch (this.variant) {
      case 'filled':
        return 'material-icons';
      case 'outlined':
        return 'material-icons-outlined';
      case 'round':
        return 'material-icons-round';
      case 'twoTone':
        return 'material-icons-two-tone';
    }
  }
}

// EL NOMBRE DEL ICONO DEBE SER EXACTAMENTE IGUAL AL DE MATERIAL ICONS
// https://fonts.google.com/icons?icon.style=Outlined&icon.set=Material+Icons
